define('components/decorators/datev-update-client',[
    'jquery',
], function($) {
    $.extend(companyInfo.decorators, {
        'datev-update-client': function() {
            var updateValueBtns = $('[data-update-value-btn]');
            var updateAllValuesBtn = $('[data-update-all-values-btn]');
            var resetBtn = $('[data-reset-btn]');
            var inputs = $('.datev-form-field-value');

            var defaultValues = [];

            // Save default values for resetting purpose
            $(inputs).each(function(i) {
                var id = $(this).attr('id');
                if (id) {
                    defaultValues.push({
                        id: id,
                        value: $(this).val()
                    });
                }
            });

            $(inputs).on('input', function() {
                var currentValues = inputs.map(function() {
                    return this.value;
                }).get();
                var isAnyInputChanged = currentValues.some(function(value, index) {
                    return value !== defaultValues[index].value;
                });
                if (isAnyInputChanged) {
                    resetBtn.prop('disabled', false);
                    resetBtn.removeClass('disabled');
                } else {
                    resetBtn.prop('disabled', true);
                    resetBtn.addClass('disabled');
                }
            });

            updateValueBtns.on('click', function(e) {
                e.preventDefault();
                var btn = $(this);
                var newValue = btn.closest('div').siblings().text();
                var relatedInput = btn.closest('.datev-form-new-value').prev();

                relatedInput.val(newValue);
                resetBtn.prop('disabled', false);
                resetBtn.removeClass('disabled');
            });

            updateAllValuesBtn.on('click', function(e) {
                e.preventDefault();
                updateValueBtns.trigger('click');
            });

            resetBtn.on('click', function(e) {
                e.preventDefault();
                defaultValues.forEach(function(val) {
                    if (val.id) {
                        $('#' + val.id).val(val.value);
                    }
                });
                resetBtn.prop('disabled', true);
                resetBtn.addClass('disabled');
            });
        }
    });
});
